import { defineNuxtRouteMiddleware, navigateTo } from '#imports';
import { useAuthStore } from '~/stores/auth';

export default defineNuxtRouteMiddleware(to => {
  const authStore = useAuthStore();

  const publicPages = ['/login', '/forgot-password', '/api/auth/callback'];
  const authRequired = !publicPages.includes(to.path);

  if (authRequired && !authStore.isAuthenticated) {
    return navigateTo('/login');
  }

  if (to.fullPath === '/') {
    return navigateTo('/countries'); // home page
  }
});
